import Carousel from 'bootstrap/js/dist/carousel';
import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';

import Alpine from 'alpinejs';
import * as utils from './utils';
import './main_store.scss';

function inner_id(obj) {
  if (obj && obj.hasOwnProperty('inner_id')) {
    return obj.inner_id;
  }
  return '';
}

function inner_id_or_name(obj) {
  if (!obj) return null;
  if (obj.hasOwnProperty('inner_id') && obj.inner_id) {
    return obj.inner_id;
  } else {
    return obj.name;
  }
}

// Add 'active' to class list of el and remove from all other li under
// the same parent of li.
// Return true is activate li has been changed.
function toggle_selected_li(el, tag='li') {
  if (el.classList.contains('active')) {
      return false;
  }
  const lis = Array.from(
    el.parentElement.querySelectorAll(':scope > ' + tag));
  lis.forEach((c) => { c.classList.remove('active'); });
  el.classList.add('active');
  return true;
}

const store_data = () => ({
  store: document.kStoreData,
  country_data: document.kCountryData,

  // All address options
  provinces: [],
  cities: [],
  districts: [],
  zipcodes: [],

  two_levels: null,
  addr_level_1: [],
  addr_level_2: [],
  addr_level_zipcode: '',

  // private fields
  _selected_pkg: null,
  _selected_country: null,
  _extra_fees: [],
  _main_options: [],
  _second_options: [],
  _total_price: 0,
  _delivery_fee: 0,
  _payment_type: null,

  // The dialog for country selection.
  _country_sel_dialog: null,
  // _order_review_dialog: null,

  init() {
    // item page.
    if (document.getElementById('cart')) {
      this._selected_pkg = this.store.product_info.product_item[0];
      this._append_or_truncate_product_options();

      if (this.store.country_data.length == 1) {
        // price is updated in select country.
        this.select_country(null, this.store.country_data[0]);
        console.log('select country for only 1 country: ' + this.store.country_data[0].country);
      } else {
        for (const cdata of this.store.country_data) {
          if (cdata.country == this.country_data.code) {
            this.select_country(null, cdata);
            console.log('select requested country: ' + cdata.country);
            break;
          }
        }
      }
      if (this.extra_fee.length > 0) {
        this._extra_fees = this.extra_fee.map((ef) => ef.fee[0]);
      }
      this._update_total_price();

      fetch('//ipinfo.io',  {
              headers: {
                'Accept': 'application/json'
              }
            })
        .then((response) => response.json())
        .then((data) => {
          this.$refs.country.value = data.country;
          console.log('detected country: ' + data.country);
        })
        .catch((err) => console.log('detect country err: ' + err));
    } else {
      if (this.store.country_data.length > 1) {
        const country_sel = document.getElementById('country_selection');
        if (!country_sel) return;
        const myModal = new Modal(country_sel, {
          backdrop: 'static',
          keyboard: false,
        });
        myModal.show();
        this._country_sel_dialog = myModal;
      }
    }

    if ('kOrderStatus' in document) {
      this.order_status = document.kOrderStatus;
    }

    // Update two level address
    if ('kTwoLevelAddress' in document) {
      console.log('Initialize two levels address');
      this.two_levels = document.kTwoLevelAddress;
      for (const c in this.two_levels) {
        this.addr_level_1.push(c);
      }
    }
    console.log('init');
  },

  get enable_store_pickup() {
    return this.country_data.store_pickup_options && this.store.enable_market_pickup;
  },

  get enable_two_level_address() {
    return this.two_levels != null;
  },

  select_two_level_city($el) {
    // Update level 2 and zipcode.
    const sel_level_1 = $el.value;
    const districts = this.two_levels[sel_level_1];
    const level_2 = [];
    for (const d in districts) {
      level_2.push(d);
    }
    this.addr_level_2 = level_2;
    this.addr_level_zipcode = '';
  },

  select_two_level_district($el) {
    // Update zipcode;
    const sel_level_1 = this.$refs.cities.value;
    const sel_level_2 = $el.value;
    const districts = this.two_levels[sel_level_1];
    const zipcode = districts[sel_level_2];
    this.addr_level_zipcode = zipcode;
  },

  get extra_fee() {
    if (this._selected_country.extra_fee &&
      this._selected_country.extra_fee.length > 0) {
      return this._selected_country.extra_fee;
    }
    return [];
  },

  get selected_country() {
    let country = '';
    if (this._selected_country) {
      country = this._selected_country.country;
    } else {
      // Parse from URL
      const urlParams = new URLSearchParams(window.location.search);
      country = urlParams.get('c');
      console.log(`Get country from url params ${country}`);
    }
    return country;
  },

  get item_url() {
    const country = this.selected_country;
    return `item?c=${country}`;
  },

  get liveshow_url() {
    const country = this.selected_country;
    return `liveshow.html?c=${country}`;
  },

  get product_number() {
    return this._selected_pkg.number;
  },

  get package_number() {
    return 1;  // Only 1 package is allowed.
  },

  get total_price() {
    return this._total_price;
  },

  get lowest_price() {
    // The lowest price from product_item
    let price = Number.MAX_SAFE_INTEGER;
    for (const pitem of this.store.product_info.product_item) {
      const cprice = this.product_price(pitem);
      if (cprice) {
        price = Math.min(price, cprice);
      }
    }
    return price;
  },

  get package_image() {
    if (this._selected_pkg && this._selected_pkg.image) {
      return this.file_path(this._selected_pkg.image);
    }
    return this.file_path(this.store.top_media[0]);
  },

  get has_second_options() {
    if (!this.store.product_info.second_options ||
        !this.store.product_info.second_options.option) {
      return false;
    }
    return this.store.product_info.second_options.option.length > 0;
  },

  get country_delivery_message() {
    if (this._selected_country) {
      return this._selected_country.delivery_message;
    }
    return "";
  },

  get url_prefix() {
    // Return the path prefix of the site. e.g. abc:8000/xxx, return /xxx
    // or return empty, so there is no ending /.
    const parts = this.store.url_prefix.split('/');
    if (parts.length > 1) {
      return '/' + parts.pop() + '/';
    }
    return '/';
  },

  // Return product price associated with country.
  // If no price, return undefined.
  product_price(product) {
    let exchange_rate = 1.0;
    if (this._selected_country) {
      if (product.hasOwnProperty('country_price')) {
        for (const country_p of product.country_price) {
          if ((country_p.country == this._selected_country.country) &&
              country_p.hasOwnProperty('price')) {
            return country_p.price;
          }
        }
      }
      if (this._selected_country.hasOwnProperty('exchange_rate')) {
        exchange_rate = this._selected_country.exchange_rate;
      }
    }
    if (product.hasOwnProperty('price')) {
      if (exchange_rate > 0) {
        return Math.ceil(product.price * exchange_rate);
      }
      return product.price;
    }

    return undefined;
  },

  _update_total_price() {
    if (!this._selected_pkg) return;

    /*let price = this._selected_pkg.price;
    this._main_options.forEach((o) => {
      if ('extra_cost' in o) {
        price += o.extra_cost;
      }
    });
    this._second_options.forEach((o) => {
      if ('extra_cost' in o) {
        price += o.extra_cost;
      }
    });*/
    let price = this.product_price(this._selected_pkg);
    let extra_fee = 0;
    for (const fee of this._extra_fees) {
      if (fee.hasOwnProperty('price')) {
        extra_fee += fee.price;
      }
    }
    this._total_price = price + this._delivery_fee + extra_fee;
    console.log('_update_total_price: ' + price + ' ' + extra_fee + ' ' + this._delivery_fee);
  },

  _append_or_truncate_product_options() {
    const pinfo = this.store.product_info;
    if (!('main_options' in pinfo) || pinfo.main_options.option.length == 0) {
      return;
    }
    const parent = document.getElementById('product_attrs');
    const template = parent.querySelector('template');
    const elements = Array.from(parent.querySelectorAll(':scope > div'));

    const first_main = pinfo.main_options.option[0];
    let second_option = null;
    if (('second_options' in pinfo) && pinfo.second_options.option.length > 0) {
      second_option = pinfo.second_options.option[0];
    }

    const num = this._selected_pkg.number;
    if (elements.length < num) {
      let diff = num - elements.length;
      for (let i = 0; i < diff; ++i) {
        const divNode = document.createElement('div');
        divNode.append(template.content.cloneNode(true));
        const seqno = '' + (elements.length + i + 1);
        divNode.setAttribute('x-data', `{seqno: ${seqno}}`);
        parent.appendChild(divNode);
        // by default select the first option.
        this._main_options.push(first_main);
        if (second_option) {
          this._second_options.push(second_option);
        }
      }
      console.log('expand product options to: ' + num);
    } else {
      while (elements.length > num) {
        const ele = elements.pop();
        ele.remove();

        this._main_options.pop();
        if (this._second_options.length > 0) {
          this._second_options.pop();
        }
      }
      console.log('truncate product options to: ' + num);
    }
  },

  is_video(fn) {
    // Returns true if the fn is a video.
    const extension = fn.split('.').pop().toLowerCase();
    return extension == 'mp4';
  },

  file_path(fn) {
    // Returns the path of fn in server which is started from '/static'.
    return '/static/' + this.store.store_name + '/' + fn;
  },

  price_with_sign(p) {
    if (this.country_data.currency_is_suffix) {
      return p + ' ' + this.country_data.currency_sign;
    }
    return this.country_data.currency_sign + ' ' + p;
  },

  select_package($el, product) {
    if ($el.classList.contains('active')) {
      return;
    }
    console.log('select package: ' + product.name);
    // If product has no price. this product is not seletable.
    if (!product.price) return;

    const products = Array.from($el.parentElement.querySelectorAll(':scope > li'));
    products.forEach((p) => { p.classList.remove('active'); });
    $el.classList.add('active');
    this._selected_pkg = product;
    this._append_or_truncate_product_options();
    this._update_total_price();
  },

  _update_address_fields(data) {
    const clear_field = (field) => {
      if (this.$refs[field]) {
        this[field] = [];
        this.$refs[field].selectedIndex = 0;
      }
    };
    const update_field = (field, new_data) => {
      if (!this.$refs[field]) return;
      if (!new_data) {
        clear_field(field);
        return;
      }
      this[field] = new_data;
      this.$refs[field].selectedIndex = 0;
    };
    if ('provinces' in data) {
      update_field('provinces', data.provinces);
      clear_field('cities');
      clear_field('districts');
      clear_field('zipcodes');
    } else if ('cities' in data) {
      update_field('cities', data.cities);
      clear_field('districts');
      clear_field('zipcodes');
    } else if ('districts' in data) {
      update_field('districts', data.districts);
      clear_field('zipcodes');
    } else if ('zipcodes' in data && !this.country_data.text_zipcode) {
      update_field('zipcodes', data.zipcodes);
    } else {
      clear_field('provinces');
      clear_field('cities');
      clear_field('districts');
      clear_field('zipcodes');
    }
  },

  select_country($el, country_data) {
    // Find country data based on selection.
    if (!country_data) {
      for (const cdata of this.store.country_data) {
        if ($el.value == cdata.country) {
          country_data = cdata;
          break;
        }
      }
      // console.log('country from select: ' + country_data);
    }

    // Dismiss popup dialog for country selection.
    if (this._country_sel_dialog) {
      this._country_sel_dialog.hide();
      this._country_sel_dialog = null;
    }
    this._selected_country = country_data;
    this._update_total_price();

    // Fetch country data.
    const url = '/api/lookup_country?c=' + country_data.country;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.country_data = data.country_data;
        this._update_address_fields(data);
      })
      .catch((err) => {
        console.log('select country error: ' + err);
        throw err;
      });
    // this._update_total_price();
    console.log('country selected: ' + country_data.country);
  },

  select_extra_fee($el, fee, index) {
    if (!toggle_selected_li($el)) return;
    if (fee) {
      this._extra_fees[index] = fee;
    }
    this._update_total_price();
  },

  _update_delivery_fee(cur_addrs) {
    this._delivery_fee = 0;
    const delivery_fee = utils.getProperty(this.country_data, 'delivery_fee');
    if (!delivery_fee) {
      return;
    }
    if (delivery_fee.hasOwnProperty('zipcode')) {
      let cur_zipcode = parseInt(cur_addrs[0]);
      if (cur_zipcode >= delivery_fee.zipcode.value) {
        this._delivery_fee = delivery_fee.fee;
      }
    } else if (delivery_fee.hasOwnProperty('addrs')) {
      let addrs = delivery_fee.addrs;
      // console.log(addrs);
      for (const cl of cur_addrs) {
        console.log('cur addr: ' + cl + ' isArray? ' + Array.isArray(addrs));
        if (Array.isArray(addrs)) {
          if (addrs.includes(cl)) {
            this._delivery_fee = delivery_fee.fee;
          }
        } else {
          if (cl in addrs) {
            addrs = addrs[cl];
            if (Array.isArray(addrs) && addrs.length == 0) {
              this._delivery_fee = delivery_fee.fee;
            }
          }
        }
      }
    }
    this._update_total_price();
  },

  select_store($el) {
    console.log('select store: ' + $el.value);
    this.$refs.address.value = $el.value;
  },

  _update_store_list() {
    // console.log('payment_type: ' + this._payment_type);
    // console.log('document.Stores:' + window.Stores);
    if (!this._payment_type || this._payment_type == 'default' || !window.Stores) {
      return;
    }

    let city = this.$refs.cities.value;
    let district = this.$refs.districts.value;
    console.log('update_store_list:' + city + '  ' + district);
    if (!city || !district) return;

    let store_list = [];
    if (this._payment_type in window.Stores) {
      const selected_stores = window.Stores[this._payment_type];
      if (city in selected_stores && district in selected_stores[city]) {
        store_list = selected_stores[city][district];
      }
    }

    let store_select = this.$refs.store_row.querySelector('select');
    let html = store_select.querySelector('option').outerHTML;
    for (const store_name of store_list) {
      html += '<option value="' + store_name + '">' + store_name + '</option>';
    }
    // console.log(html);
    store_select.innerHTML = html;
  },
  select_payment($el, type) {
    //console.log('select_payment: ' + type);
    let payments = document.querySelectorAll('label[name="payment"]');
    // console.log("payment length: ", payments.length);
    payments.forEach(el => {
      el.classList.remove('active');
    });
    $el.classList.add('active');
    this._payment_type = type;
    if (type == 'default') {
      this.$refs.store_row.classList.add('d-none');
      this.$refs.address.readOnly = false;
      // Remove required.
      document.getElementById('market_stores').removeAttribute("required");
    } else {
      this.$refs.store_row.classList.remove('d-none');
      this.$refs.address.readOnly = true;
      document.getElementById('market_stores').setAttribute("required", true);
      // update store list.
      this._update_store_list();
    }
  },

  select_address($el, addr_level) {
    this._update_store_list();
    const addr_levels = [this._selected_country.country]
    if (addr_level == 'province') {
      addr_levels.push($el.value);
    } else if (addr_level == 'city') {
      if (this.country_data.city_from_zipcode) {
        return;
      }
      if (this.$refs.provinces) {
        addr_levels.push(this.$refs.provinces.value);
      }
      addr_levels.push($el.value);
    } else if (addr_level == 'district') {
      if (this.$refs.provinces) {
        addr_levels.push(this.$refs.provinces.value);
      }
      if (this.$refs.cities) {
        addr_levels.push(this.$refs.cities.value);
      }
      addr_levels.push($el.value);
      if (this.country_data.text_zipcode ||
          !this.country_data.zipcode_label) {
        this._update_delivery_fee(addr_levels.slice(1));
        return;
      }
    }

    this._update_delivery_fee(addr_levels.slice(1));
    const params = addr_levels.map(x => 'rl=' + x);
    const url = '/api/lookup_addr?' + params.join('&');
    // console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((data) => this._update_address_fields(data))
      .catch((err) => {
        console.log('select address error: ' + err);
      });
  },

  select_text_zipcode($el) {
    // verify the value.
    if (this.country_data.hasOwnProperty('zipcode_length') &&
        $el.value.length != this.country_data.zipcode_length) {
      // console.log('text zipcode: ' + $el.value);
      $el.setCustomValidity(this.country_data.zipcode_label);
    } else {
      $el.setCustomValidity("");
    }

    this._update_delivery_fee([$el.value]);
    if (!utils.getProperty(this.country_data, 'city_from_zipcode')) {
      return;
    }
    // It's specific for hun which has zipcode and city. when zipcode is selected, fetch cities.
    const addr_levels = [this._selected_country.country, $el.value];
    const params = addr_levels.map(x => 'rl=' + x);
    const url = '/api/lookup_addr?' + params.join("&");
    // console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((data) => this._update_address_fields(data))
      .catch((err) => {
        console.log('select text zipcode error: ' + err);
      });
  },

  combined_option(seqno) {
    seqno = seqno - 1;
    if (seqno >= this._main_options.length) return '';

    const options = [];
    // console.log(this._main_options);
    // console.log(this._second_options);
    const main_option = this._main_options[seqno];
    const main_option_id = inner_id_or_name(main_option);
    if (main_option_id == null) {
      return;
    }
    options.push(main_option_id);

    if (this._second_options) {
      const second_option = this._second_options[seqno];
      options.push(inner_id_or_name(second_option));
    }

    // console.log('combined option for seqno: ' + seqno + ': ' + options.join(","));
    return options.join(",");
  },

  select_main_product_option($el, option, seqno) {
    if (!toggle_selected_li($el, 'div')) return;

    this._main_options[seqno - 1] = option;
    this._update_total_price();
  },

  select_second_product_option($el, option, seqno) {
    if (!toggle_selected_li($el)) return;

    this._second_options[seqno - 1] = option;
    this._update_total_price();
  },

  submit_form(event) {
    // console.log('submit form');
    // Update product in form
    this.$refs.product.value = this._selected_pkg.name;
    this.$refs.product_id.value = inner_id(this._selected_pkg);

    const formElement = document.querySelector('form');
    const form = new FormData(formElement);
    const requestedData = {
        product: form.get('product'),
        price: form.get('price'),
        name: form.get('name'),
        phone_number: form.get('phonenumber'),
        province: form.get('province'),
        city: form.get('city'),
        district: form.get('district'),
        zipcode: form.get('zipcode'),
        address: form.get('address'),
        house_number: form.get('house_number'),
        email: form.get('email'),
        comment: form.get('comment'),
    };

    /*const orderReview = document.querySelector('#order_review');
    const modalElement = orderReview.content.cloneNode(true).querySelector('div');
    modalElement.setAttribute('x-data', JSON.stringify(data));
    orderReview.parentElement.appendChild(modalElement);
    const myModal = new Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });
    myModal.show();
    this._order_review_dialog = myModal;

    // this.postcheck_form(event);
    const track_url = '/api/track_page?sn=' + this.store.store_name +
      '&p=order_review';
    console.log('Track: ' + track_url);
    fetch(track_url);*/
    this.confirm_order(event, requestedData);
  },
  confirm_order(event, requestedData) {
    console.log('confirm order');
    // console.log(event);
    /*this._order_review_dialog.hide();
    this._order_review_dialog.dispose();
    this._order_review_dialog = null;*/

    this.postcheck_form(event, requestedData);
  },

  postcheck_form(event, requestedData) {
    // Get form data
    const formElement = document.querySelector('form');
    formElement.classList.add("was-validated");
    const form = new FormData(formElement);
    if (!form.has('selected_country')) {  // Only 1 country, so selected_country is not a <select>
      form.set('selected_country', this._selected_country.country);
    }
    // console.log(form);

    // Verify required address.
    const addrLevels = new Map([
      ['provinces', 'province'],
      ['cities', 'city'],
      ['districts', 'district'],
      ['zipcodes', 'zipcode']
    ]);
    const verify_addr_field = (ref_name, form_name) => {
      if (!this.$refs[ref_name]) return true;
      if (!form.get(form_name)) {
        return false;
      }
      return true;
    };
    for (const [ref_name, form_name] of addrLevels.entries()) {
      if (!verify_addr_field(ref_name, form_name)) {
        alert('Please fill city, zipcode, etc.');
        return;
      }
    }
    if (this._payment_type && this._payment_type != 'default') {
      form.set('payment_type', this._payment_type);
    }

    // Submit order
    // console.log(this._selected_country.currency);
    const url = this.url_prefix + 'confirmation';
    const callback = (data) => {
      let order_status = null;
      if (data != null) {
        order_status = {
          success: true,
          ...data
        };
        fbq('track', 'Purchase', {
          value: '' + this._total_price,
          currency: this.country_data.currency,
          content_name: this.store.url_prefix
        });
      } else {
        order_status = {
          success: false,
        }
      }
      order_status = {
        ...order_status,
        ...requestedData
      }

      const submitted_rv = document.querySelector('#submitted_rv');
      const modalElement = submitted_rv.content.cloneNode(true).querySelector('div');
      modalElement.setAttribute('x-data', JSON.stringify(order_status));
      submitted_rv.parentElement.appendChild(modalElement);
      const myModel = new Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });
      myModel.show();
    };

    fetch(url, {
      method: 'POST',
      body: form
    })
      .then((response) => response.json())
      .then((data) => {
        callback(data);
      })
      .catch((err) => {
        callback(null);
        console.log('post order error: ' + err);
      })
      .finally(() => {
        formElement.classList.remove("was-validated");
      });

    const track_url = '/api/track_page?sn=' + this.store.store_name +
      '&p=order_submit';
    console.log('Track: ' + track_url);
    fetch(track_url);
  },

  order_status_img_path(success) {
    return '/static/api/order_' + (success ? 'success' : 'failed') + '.png';
  },
  return_homepage() {
    console.log('return_homepage');
  },
});

window.Alpine = Alpine;  // for debug.
window.goto_top = function() {
    utils.gotoTop();
};

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('store_data', store_data);
  });
  document.addEventListener('alpine:initialized', () => {
    // console.log('alpine::initialized');
    let labels = utils.getProperty(document.kCountryData, 'store_pickup_options');
    if (labels) {
      utils.loadScript('/static/common/js/markets.min.js');
    }
  });
  Alpine.start();
});
